import { ChoiceButton } from "swing-components";

import { type FeedbackRating } from "~components/ModalSubFeedback/ModalSubFeedback";
import { translate } from "~utils";

/********* Types ********/
type SubQuickReviewPromptProps = {
  subName?: string;
  onRatingChange: (rating: FeedbackRating) => void;
};

/********* Component ********/
export function SubQuickReviewPrompt(props: SubQuickReviewPromptProps) {
  const { subName, onRatingChange } = props;

  return (
    <div>
      <p css={{ fontWeight: 600, margin: "8px 0" }}>
        {translate("MSF_FEEDBACK_QUESTION_INVITE_BACK", subName)}
      </p>
      <div css={{ display: "flex", gap: 16 }}>
        <ChoiceButton
          icon={{ name: "Face Positive", color: "green500" }}
          value="RATING_POSITIVE"
          onChange={(rating: string) => {
            onRatingChange(rating as FeedbackRating);
          }}
        />
        <ChoiceButton
          icon={{ name: "Face Neutral", color: "yellow600" }}
          value="RATING_NEUTRAL"
          onChange={(rating: string) => {
            onRatingChange(rating as FeedbackRating);
          }}
        />
        <ChoiceButton
          icon={{ name: "Face Negative", color: "red500" }}
          value="RATING_NEGATIVE"
          onChange={(rating: string) => {
            onRatingChange(rating as FeedbackRating);
          }}
        />
      </div>
    </div>
  );
}
